import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as UploadIconSvg } from '../../assets/upload-icon.svg';

export const UploadIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={UploadIconSvg} {...props} />;
};
